const CONFIRM_EMAIL_PATH_PREFIX = '/confirmEmailAndActivateAccount/';
const RESET_PASSWORD_PATH_PREFIX = '/resetPassword';
const JOIN_TO_COURSE_PATH_PREFIX = '/j/';

const confirmEmailAndActivateAccountPage = (code: string): string =>
  `${CONFIRM_EMAIL_PATH_PREFIX}${code}`;

const resetPasswordPage = (hash: string): string => `${RESET_PASSWORD_PATH_PREFIX}/${hash}`;

const joinToCoursePage = (joinCode: string): string => `${JOIN_TO_COURSE_PATH_PREFIX}${joinCode}`;

const courseSettingsPage = (id: string): string => `/course/${id}/settings`;

const coursePage = (id: string): string => `/course/${id}`;

const organizationUsersPage = (organizationId: string): string =>
  `/admin/organizations/${organizationId}/users`;

const organizationInvitationsPage = (organizationId: string): string =>
  `/admin/organizations/${organizationId}/invitations`;

const trainerInviteAcceptPageByToken = (token: string): string => `/i/${encodeURIComponent(token)}`;

const adminUserDetail = (userId: string): string => `/admin/users/${userId}`;

const adminPermissionDetail = (permissionId: string): string =>
  `/admin/permissions/${permissionId}`;

export const routePaths = {
  adminUserDetail: '/admin/users/:userId',
  adminPermissionDetail: '/admin/permissions/:permissionId',
  trainerInviteByToken: '/i/:token'
} as const;

export const urls = {
  homePage: '/',
  loginPage: '/login',
  registrationPage: '/registration',
  confirmEmailAndActivateAccountPage,
  forgotPasswordPage: '/forgotPassword',
  resetPasswordPage,
  joinToCoursePage,
  courseSettingsPage,
  coursePage,
  createCoursePage: '/courses/create',
  organizationUsersPage,
  organizationInvitationsPage,
  trainerInviteAcceptPageByToken,
  adminPanel: '/admin',
  adminHealthPage: '/admin/health',
  adminOrganizationsPage: '/admin/organizations',
  adminUsersPage: '/admin/users',
  adminTrainersPage: '/admin/trainers',
  adminPermissionsPage: '/admin/permissions',
  adminCachePage: '/admin/cache',
  adminSynchronizationPage: '/admin/synchronization',
  adminLoginActivityPage: '/admin/login-activity',
  adminInvitationsPage: '/admin/invitations',
  regulationsPage: '/regulations',
  privacyPolicyPage: '/privacyPolicy',
  unauthorizedPage: '/401',
  forbiddenPage: '/403',
  notFoundPage: '/404',
  treneoSite: 'https://treneo.pl',
  adminUserDetail,
  adminPermissionDetail,
  routePaths
};

const TRAINER_INVITE_PATH_PREFIX = '/i';

export const PUBLIC_AUTH_PATH_PREFIXES: readonly string[] = [
  urls.forgotPasswordPage,
  RESET_PASSWORD_PATH_PREFIX,
  JOIN_TO_COURSE_PATH_PREFIX,
  CONFIRM_EMAIL_PATH_PREFIX,
  TRAINER_INVITE_PATH_PREFIX
];
